import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import DataStore from "./../../../stores/DataStore";

/**
 * @class
 * Zur Anzeige von TextAreas
 * @name TextAreaAttribute
 * @implements {Attribute}
 */
class TextAreaAttribute extends Component {
  constructor(params) {
    super(params);
  }

  onChange(evt) {
    const { attribute: { onChange, value = "" } = {} } = this.props;
    onChange(evt.target.value);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = "" } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  render() {
    const {
      attribute: {
        id = "",
        name = "",
        description = "",
        tooltip = "",
        type = "",
        rules = [],
        attributeOption: { Field = TextField, InputProps = {} },
        onChange,
        value,
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.id = id;
    return (
      <Field
        disabled={DataStore.attributeValues[this.id].readOnly}
        style={{
          flexGrow: 1,
          marginRight: "5px",
        }}
        key={id}
        id={id}
        name={name}
        label={name}
        multiline
        InputLabelProps={{ shrink: true }}
        // style={{ float: 'right' }}
        // margin="dense"
        onChange={(evt) => this.onChange(evt)}
        value={DataStore.attributeValues[this.id].value}
        {...InputProps}
      />
    );
  }
}

export default TextAreaAttribute;
